import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import itLocale from "date-fns/locale/it";
import { LocalizationProvider } from '@mui/x-date-pickers'
import AdapterLuxon from "@mui/lab/AdapterLuxon";

import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";

import { messages as messagesEn } from "./locales/en/messages";
import { messages as messagesIt } from "./locales/it/messages";

import "index.scss";

import { it as pluralsIt } from 'make-plural/plurals'

import App from "./App";

import {
	createTheme,
	ThemeProvider,
} from "@mui/material/styles";

import { alpha } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: process.env.REACT_APP_PRIMARY_COLOR || "#000000",
		},
		secondary: {
			main: process.env.REACT_APP_SECONDARY_COLOR || "#000000",
		},
		warning: {
			main: "#ff9800",
		},
	},
	typography: {
		fontFamily: [
			"'Barlow'",
			"sans-serif"
		].join(","),
		fontSize: 16,
		h1: {
			fontSize: 40,
			fontWeight: "bold",
		},
		h2: {
			fontSize: 27,
			fontWeight: "bold",
		},
		h3: {
			fontSize: 16,
			fontWeight: "bold",
		},
		h4: {
			fontSize: 14,
			fontWeight: "bold",
		},
		h5: {
			fontWeight: "bold",
		},
		body1: {
			fontSize: 16,
		},
		body2: {
			fontSize: 14,
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: "0px",
					fontSize: "1rem"
				}
			}
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					overflow: "hidden",
					borderRadius: "0px",
					backgroundColor: "#FFFFFF",
					"&:hover": { backgroundColor: "#FFFFFF", },
					"&.Mui-focused": {
						backgroundColor: "#FFFFFF",
						boxShadow: `${alpha("#000000", 0.25)} 0 0 0 2px`,
						borderColor: "#000000",
					}
				}
			}
		},
		MuiMenu: {
			styleOverrides: {
				root: {
					top: "30px",
				}
			}
		},
	},
}, itLocale);


i18n.loadLocaleData({
	"it": { plurals: pluralsIt },
});

i18n.load({
	"it": messagesIt,
	"en": messagesEn
});

i18n.activate("it");

ReactDOM.render(
	<React.StrictMode>
		{/*@ts-ignore*/}
		<I18nProvider i18n={i18n}>
			<ThemeProvider theme={theme}>
				<BrowserRouter>
					<SnackbarProvider
						maxSnack={5}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "right",
						}}
						hideIconVariant={false}>
						<LocalizationProvider dateAdapter={AdapterLuxon} locale="it">
							<App />
						</LocalizationProvider>
					</SnackbarProvider>
				</BrowserRouter>
			</ThemeProvider>
		</I18nProvider>
	</React.StrictMode>, document.getElementById("root"));

reportWebVitals();
